import { SapSuppliersDetail } from "@/features"

const SapSupplierDetailPage = () => {
  return <SapSuppliersDetail />
}

export default SapSupplierDetailPage
